module.exports = __webpack_public_path__ + "static/media/millermatthewkheadshot20210907.7eb2b9cd.png";